import { createFileRoute } from '@tanstack/react-router'
import { requireGuest } from '@/lib/auth-guard'

function safeRedirect(raw: unknown): string | undefined {
  if (typeof raw !== 'string') return undefined
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return undefined
  return raw
}

export const Route = createFileRoute('/register')({
  validateSearch: (raw: Record<string, unknown>): { email?: string; redirect?: string } => ({
    email: typeof raw.email === 'string' ? raw.email : undefined,
    redirect: safeRedirect(raw.redirect),
  }),
  beforeLoad: () => requireGuest(),
})
